
















































import { Component, Watch, Vue, Emit } from 'vue-property-decorator';
import { institutionServer, patrolManagementServe, professionServer } from '@/api/installServer';
import dayjs from 'dayjs';
import { arrayToTree } from '@/util/array';

@Component({
  components: {},
})
export default class PatrolReceiveEdit extends Vue {
  private visible = false;
  private type = '';

  spaceId: any = ''; // 单位id

  private form: any = {
    name: '', // 巡检名称
    spaceDepartmentId: '', // 部门id
    spacePostId: '', // 岗位id
    patrolLineId: '', // 巡检线路id
    time: ['00:00:00', '23:59:59'], // 执行时间
    enableFlag: 1, // 任务是否启用 1启用 0不启用
    patrolLineToFrequencyNumFlag: false, // 按照次数巡检
    startTimeToReceiveTimeFlag: false, // 按照领取时间开始计时
    frequencyNum: 1, //巡检次数
  };
  private patrolLineList: any = []; // 巡检线路列表
  private postList: any = []; // 岗位列表
  private deptList: any = []; // 部门列表

  private receiveRules: any = {
    name: [{ required: true, message: '请输入巡检名称', trigger: 'blur' }],
    spaceDepartmentId: [{ required: true, message: '请选择部门', trigger: 'blur' }],
    patrolLineId: [{ required: true, message: '请选择巡检线路', trigger: ['blur', 'change'] }],
    time: [
      { required: true, message: '请选择执行时间', trigger: ['blur', 'change'] },
      { validator: this.checkTime, trigger: ['blur', 'change'] },
    ],
  };

  /**
   * 窗口标题
   * @Params
   * @return
   **/
  get title() {
    const typeMap: any = {
      add: '添加巡检任务',
      edit: '编辑巡检任务',
    };
    return typeMap[this.type];
  }

  /**
   * 验证执行时间是否包括最大巡检时间
   * @Params
   * @return
   **/
  checkTime(rule: any, value: any, callback: any) {
    if (!value[0] || !value[1]) {
      callback(new Error('请选择执行时间'));
    }
    let maxFrequency: any = -1;
    this.patrolLineList.forEach((item: any) => {
      if (item.id === this.form.patrolLineId && item.frequencyUnit === 'hour') {
        maxFrequency = item.maxFrequency;
      }
    });
    const time1: any = new Date('2019-11-06 ' + value[0]);
    let time2: any = '';
    if (value[1] <= value[0]) {
      time2 = new Date('2019-11-07 ' + value[1]);
    } else {
      time2 = new Date('2019-11-06 ' + value[1]);
    }

    if (maxFrequency === 0 || (time2 - time1) / 1000 / 60 / 60 < maxFrequency) {
      callback(new Error('该线路的最大巡检时间大于所选的执行时间'));
    }

    callback();
  }

  /**
   * 打开新增窗口
   * @Params
   * @return
   **/
  private showAddDialog() {
    this.type = 'add';
    this.visible = true;
    this.getPostList();
    this.getSpaceDeptList();
    this.getPatrolLineList();
  }

  /**
   * 打开编辑窗口
   * @Params
   * @return
   **/
  private showEditDialog(id: string) {
    this.type = 'edit';
    this.getPostList();
    this.getSpaceDeptList();
    this.getPatrolLineList();
    this.getReceiveData(id);
    this.visible = true;
  }

  /**
   * 关闭窗口
   * @Params
   * @return
   **/
  hideDialog() {
    this.resetForm();
    this.visible = false;
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      switch (this.type) {
        case 'add':
          this.addReceiveData();
          break;
        case 'edit':
          this.editReceiveData();
          break;
      }
    });
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    const formComponent: any = this.$refs['form'];
    formComponent.resetFields();
    this.form.patrolLineToFrequencyNumFlag = false;
    this.form.startTimeToReceiveTimeFlag = false;
    this.form.frequencyNum = 1;
  }

  /**
   *【接口】获取岗位
   * @Params
   * @return
   **/
  async getPostList() {
    try {
      const res: any = await professionServer.getPageDataAll({});
      if (res.code === '200') {
        this.postList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }
  /**
   *【接口】获取部门
   * @Params
   * @return
   **/
  async getSpaceDeptList() {
    try {
      const res: any = await institutionServer.getDeptAndSubDeptList({});
      if (res.code === '200') {
        this.deptList = arrayToTree(res.data);
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】获取巡检线路
   * @Params
   * @return
   **/
  async getPatrolLineList() {
    try {
      const res: any = await patrolManagementServe.getPatrolLineListAll({ paging: false });
      if (res.code === '200') {
        this.patrolLineList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】获取任务详情
   * @Params
   * @return
   **/
  async getReceiveData(id: string) {
    try {
      const res: any = await patrolManagementServe.getPatrolTaskReceiveInfoData(id);
      if (res.code === '200') {
        this.form = res.data;
        this.form.time = [res.data.workStartTime, res.data.workEndTime];
      }
    } catch (e) {
      this.$message.warning('网络异常，请稍后重试。');
    }
  }

  /**
   *【接口】添加任务
   * @Params
   * @return
   **/
  async addReceiveData() {
    const workStartTime = typeof this.form.time[0] === 'string' ? this.form.time[0] : dayjs(this.form.time[0], 'HH:mm:ss');
    const workEndTime = typeof this.form.time[1] === 'string' ? this.form.time[1] : dayjs(this.form.time[1], 'HH:mm:ss');
    try {
      const res: any = await patrolManagementServe.addPatrolTaskReceive({
        name: this.form.name,
        spaceDepartmentId: this.form.spaceDepartmentId,
        spacePostId: this.form.spacePostId,
        patrolLineId: this.form.patrolLineId,
        workStartTime,
        workEndTime,
        enableFlag: this.form.enableFlag,
        patrolLineToFrequencyNumFlag: this.form.patrolLineToFrequencyNumFlag,
        startTimeToReceiveTimeFlag: this.form.startTimeToReceiveTimeFlag,
        frequencyNum: this.form.frequencyNum,
      });
      if (res.code === '200') {
        this.hideDialog();
        this.onResponse();
        this.$message.success('您成功添加了记录。');
      } else {
        this.$message.warning('添加失败');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】编辑任务
   * @Params
   * @return
   **/
  async editReceiveData() {
    try {
      const res: any = await patrolManagementServe.editPatrolTaskReceiveData(this.form.id, {
        name: this.form.name,
        spaceDepartmentId: this.form.spaceDepartmentId,
        spacePostId: this.form.spacePostId,
        patrolLineId: this.form.patrolLineId,
        workStartTime: this.form.time[0],
        workEndTime: this.form.time[1],
        enableFlag: this.form.enableFlag,
        patrolLineToFrequencyNumFlag: this.form.patrolLineToFrequencyNumFlag,
        startTimeToReceiveTimeFlag: this.form.startTimeToReceiveTimeFlag,
        frequencyNum: this.form.frequencyNum,
      });
      if (res.code === '200') {
        this.hideDialog();
        this.onResponse();
        this.$message.success('您成功编辑记录。');
      } else {
        this.$message.warning('编辑失败。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【广播】广播提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {}
}
